import {
  getCommonProductTerms,
  getVerticalWidgetProductTerms,
  ServicesWithTerms,
} from '@sravni/react-ugc/lib/ProductTerms';
import { COMMON_OFFERS } from '@sravni/ugc/lib/specialOffers/lists';
import type { CommonOffersType } from '@sravni/ugc/lib/specialOffers/types';

import type { OfferTab } from '../../helpers/getTabsInfo';

export const offersTabsInfo: Record<CommonOffersType, OfferTab> = {
  [COMMON_OFFERS.savings]: {
    key: { type: COMMON_OFFERS.savings },
    label: 'Вклады',
    generalLink: '/vklady/',
    generalLinkLabel: 'Все вклады',
    linkToOneProduct: 'vklad',
    getConditions: getCommonProductTerms(ServicesWithTerms.savings),
    advertisingCategory: 'Вклады',
    getVerticalWidgetConditions: getVerticalWidgetProductTerms(ServicesWithTerms.savings),
  },
  [COMMON_OFFERS.accumulative]: {
    key: { type: COMMON_OFFERS.accumulative },
    label: 'Накопительные счета',
    generalLink: '/vklady/?accumulativeTypes=accumulative',
    generalLinkLabel: 'Все накопительные счета',
    linkToOneProduct: 'vklad',
    getConditions: getCommonProductTerms(ServicesWithTerms.accumulativeDeposit),
    getVerticalWidgetConditions: getVerticalWidgetProductTerms(ServicesWithTerms.accumulativeDeposit),
    advertisingCategory: 'Накопительные счета',
  },
  [COMMON_OFFERS.credits]: {
    key: { type: COMMON_OFFERS.credits },
    label: 'Кредиты',
    generalLink: '/kredity/',
    generalLinkLabel: 'Все кредиты',
    linkToOneProduct: 'kredit',
    getConditions: getCommonProductTerms(ServicesWithTerms.credits),
    getVerticalWidgetConditions: getVerticalWidgetProductTerms(ServicesWithTerms.credits),
    advertisingCategory: 'Кредиты',
  },
  [COMMON_OFFERS.mortgage]: {
    key: { type: COMMON_OFFERS.mortgage },
    label: 'Ипотека',
    generalLink: '/ipoteka/',
    generalLinkLabel: 'Все ипотечные кредиты',
    linkToOneProduct: 'ipoteka',
    getConditions: getCommonProductTerms(ServicesWithTerms.mortgage),
    advertisingCategory: 'Ипотека',
    getVerticalWidgetConditions: getVerticalWidgetProductTerms(ServicesWithTerms.mortgage),
  },
  [COMMON_OFFERS.creditCards]: {
    key: { type: COMMON_OFFERS.creditCards },
    label: 'Кредитные карты',
    generalLink: '/karty/',
    generalLinkLabel: 'Все кредитные карты',
    linkToOneProduct: 'kreditnaja-karta',
    getConditions: getCommonProductTerms(ServicesWithTerms.creditCards),
    getVerticalWidgetConditions: getVerticalWidgetProductTerms(ServicesWithTerms.creditCards),
    advertisingCategory: 'Кредитные карты',
  },
  [COMMON_OFFERS.debitCards]: {
    key: { type: COMMON_OFFERS.debitCards },
    label: 'Дебетовые карты',
    generalLink: '/debetovye-karty/',
    generalLinkLabel: 'Все дебетовые карты',
    linkToOneProduct: 'debetovaja-karta',
    getConditions: getCommonProductTerms(ServicesWithTerms.debitCards),
    getVerticalWidgetConditions: getVerticalWidgetProductTerms(ServicesWithTerms.debitCards),
    advertisingCategory: 'Дебетовые карты',
  },
  [COMMON_OFFERS.loan]: {
    key: { type: COMMON_OFFERS.loan },
    label: 'Займы',
    generalLink: '/zaimy/',
    generalLinkLabel: 'Все займы',
    linkToOneProduct: 'mfo',
    getConditions: getCommonProductTerms(ServicesWithTerms.microcredits),
    getVerticalWidgetConditions: getVerticalWidgetProductTerms(ServicesWithTerms.microcredits),
    advertisingCategory: 'Микрокредиты',
    buttonAction: 'Взять займ',
  },
  [COMMON_OFFERS.brokerskoeObsluzhivanie]: {
    key: { type: COMMON_OFFERS.brokerskoeObsluzhivanie },
    label: 'Брокерское обслуживание',
    generalLink: '/invest/brokerskoe-obsluzhivanie/',
    generalLinkLabel: 'Все предложения по брокерскому обслуживанию',
    linkToOneProduct: '',
    getConditions: getCommonProductTerms(ServicesWithTerms.broker),
    getVerticalWidgetConditions: getVerticalWidgetProductTerms(ServicesWithTerms.broker),
    advertisingCategory: 'Брокерское обслуживание',
  },
  [COMMON_OFFERS.bankrotstvo]: {
    key: { type: COMMON_OFFERS.bankrotstvo },
    label: 'Банкротство физ. лиц',
    generalLink: '/bankrotstvo/',
    generalLinkLabel: 'Все предложения по банкротству физических лиц',
    linkToOneProduct: '',
    getConditions: getCommonProductTerms(ServicesWithTerms.bankrotstvo),
    getVerticalWidgetConditions: getVerticalWidgetProductTerms(ServicesWithTerms.bankrotstvo),
    advertisingCategory: 'Банкротство',
  },
};
